import type { Phrases } from '../../common/Phrases.d';


import React, { useEffect, useRef } from 'react';
import { Fieldset } from '/react4xp/components/react-hook-form/Fieldset';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { WhenButtonGroup } from './WhenButtonGroup';
import { WhenOtherTextField } from './WhenOtherTextField';
import { ANONYMOUS_FIELD_NAME } from '../constants';


const WHEN_LEGEND_ID = 'whenLegend';


export const WhenFieldset = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const label = phrases['notificationForm.anonymous.whenField.label'];

	const scrollRef = useRef();

	const {
		setScrollRef,
	} = useFormContext();

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN, el: scrollRef.current });
			setScrollRef({
				field: ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN_OTHER, el: scrollRef.current,
			});
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			legend={label}
			legendId={WHEN_LEGEND_ID}
			legendRef={scrollRef}
			required
		>
			<WhenButtonGroup
				aria-labelledby={WHEN_LEGEND_ID}
				errorSummaryLabel={label}
				phrases={phrases}
			/>
			<WhenOtherTextField
				phrases={phrases}
			/>
		</Fieldset>
	);
};
